<template>
  <div v-if="data" class="modal--addUser">
    <div class="modalCustom__header">
      <h5 class="">{{ data.header }}</h5>
      <hr class="modalCustom__header-border" />
    </div>

    <div class="modalCustom__body">
      <div class="row">
        <div class="col">
          <fg-input type="text" label="Token Name *" placeholder="MainToken" v-model="form.name"> </fg-input>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <label for="scopes" class="control-label">Scopes*</label>
          <multiselect
            v-model="form.scopes"
            :options="data.scopes"
            track-by="id"
            id="scopes"
            label="name"
            :searchable="true"
            :multiple="true"
            :close-on-select="false"
            :show-labels="false"
          >
            <template slot="singleLabel" slot-scope="props">
              <span class="option__title">{{ props.option.name }}</span>
            </template>
            <template slot="option" slot-scope="props">
              <div class="option">
                <div class="desc">
                  <span class="option__title">{{ props.option.name }}</span>
                  <span class="option__small">{{ props.option.description }}</span>
                </div>
              </div>
            </template>
          </multiselect>
        </div>
      </div>
    </div>

    <div class="modalCustom__footer">
      <!--            buttons                   -->
      <div class="mr-3">
        <p-button type="danger" round @click.native.prevent="closeModal">
          {{ $t('Cancel') }}
        </p-button>
      </div>
      <div>
        <p-button type="success" :loading="saving" round @click.native.prevent="createToken">
          {{ $t('save') }}
        </p-button>
      </div>
    </div>
  </div>
</template>

<script>
import GenerateDashboardTokenController from '@/controllers/PublicData/GenerateDashboardTokenController';

export default {
  name: 'GenerateTokenModal',
  props: {
    data: {},
  },
  data() {
    return {
      form: {},
      saving: false,
    };
  },
  mounted() {
    this.setClientInfo();
  },
  methods: {
    async createToken() {
      this.saving = true;
      try {
        let token = await GenerateDashboardTokenController.store(this.form);
        this.$emit('submit', token);
        this.closeModal();
      } catch (error) {
        Object.entries(error.response.data).forEach((item) => {
          this.$notify({
            type: 'danger',
            title: item[1],
          });
        });
      }
      this.saving = false;
    },
    closeModal() {
      this.$emit('close');
    },
    setClientInfo() {
      this.form.client_id = this.data.client.id;
      this.form.redirect = this.data.client.redirect;
    },
  },
};
</script>

<style scoped>
.desc {
  text-align: start;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
</style>
